import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-117" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-118" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-119" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-120" data-mp="tyv5tcf1sfy9">🏆 </span>Offerta Speciale di Lancio
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-121" data-mp="u0xunt4gs31e">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-122" data-mp="13x15dnddt9zy">
            GINNASTICA ARTISTICA PRONTA™ Pack
          </span>

          <dl data-id="element-123" data-mp="2fbepch50l5ap">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-124" data-mp="2fe0y2k3n5qui">
                <dt className="text-ink/80" data-id="element-125" data-mp="pjp8ru1dymmr">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-126" data-mp="uise7fla2uv9">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-127" data-mp="zi52m4rss9zy">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-128" data-mp="13k9twwurwujf">
                Valore Totale:
              </dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-129" data-mp="6v0wfwgyxpml">€225</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-130" data-mp="btc6a779k04t">
            Solo per oggi
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-131" data-mp="kkvysblb5drc">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-132" data-mp="3k8vvmv4tcyel">
              🏆
            </span>
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-133" data-mp="3o9pdp7vkrizk">
              €19
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-134" data-mp="ve62icgpbtuc">
            <span aria-hidden="true" data-id="element-135" data-mp="qg4i9o7jhoha">💳 </span>Pagamento unico, accesso a vita.
            Nessun abbonamento.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-136" data-mp="157d4dnc8grpo" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-137" data-mp="1067ctsub7ahq">
            Download Istantaneo · Pagamento Unico · Accesso a Vita · Garanzia di
            14 Giorni
          </p>
        </div>
      </div>
    </section>;
}